/* eslint-disable */
import React, { useState, useEffect, useCallback } from 'react';
import cls from 'classnames';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';
import ReactIdSwiper from 'react-id-swiper';
import { Swiper, Navigation, Pagination } from 'swiper/dist/js/swiper.esm';
import { safeId, getArgByPath } from '~/config/data-cover';
import { ensureSlashEnd } from '~/utils/string/ensureSlashEnd';
import { FiatBrand } from '~/components/FiatBrand';
import { Picture } from '~/components/Elements/Picture';
import { Img } from '~/components/Elements/Img';
import { DataLayer } from '~/components/DataLayer';
import isString from '@dcode/is/string/string';
import css from './Tabs.scss';
import secondCss from '../../../GalleryPage/GalleryPage.scss';
import Fade from 'react-reveal/Fade';
import { BlueArrowButton } from '~/components/ArrowButton';

const classes = {
	root: css.tabs,
	poster: css.tabsPoster,
	posterList: css.tabsPosterList,
	posterItem: css.tabsPosterItem,
	posterPicture: css.tabsPosterPicture,
	posterImage: css.tabsPosterImage,
	posterVideo: css.tabsPosterVideo,
	posterCaption: css.tabsPosterCaption,
	posterCaptionWrapper: css.tabsPosterCaptionWrapper,
	posterCaptionIcon: css.tabsPosterCaptionIcon,
	posterCaptionIconBrand: css.tabsPosterCaptionIconBrand,
	posterCaptionText: css.tabsPosterCaptionText,
	posterLoader: css.tabsPosterLoader,
	info: css.tabsInfo,
	infoTitle: css.tabsInfoTitle,
	infoText: css.tabsInfoText,
	tab: css.tabsTab,
	tabList: css.tabsTabList,
	tabItem: css.tabsTabItem,
	tabLink: css.tabsTabLink,
	bullet: css.tabsBullet,
	bulletList: css.tabsBulletList,
	bulletListDesktop : css.tabsBulletListDesktop,
	bulletItem: css.tabsBulletItem,
	isActive: css.isActive,
	isSimple: css.isSimple,
	thumb: secondCss.galleryPageThumb,
	thumbItem: secondCss.galleryPageThumbItem,
	thumbImage: secondCss.galleryPageThumbImage,
	arrowPrev: secondCss.galleryPageArrowPrev,
	arrowNext: secondCss.galleryPageArrowNext,
};

const propTypes = {
	match: PropTypes.shape({
		params: PropTypes.shape({
			id: PropTypes.string,
		}),
	}),
};

const defaultProps = {
	className: '',
	classes,
};

const extractIndexFromUrl = (pathname) => {
	const pathArray = ensureSlashEnd(pathname, false).split('/');
	return pathArray.length > 2 ? pathArray.pop() : 0;
};

export const Tabs = ({ className, classes, location, match, ...props }) => {
	var isMobileGallery = undefined;
	if (screen.width < 640 || screen.height < 480) {
		isMobileGallery = true;
		console.log('TAAABS :: CELULAR');
	} else if (screen.width < 1024 || screen.height < 768) {
		isMobileGallery = true;
		console.log('TAAABS :: TABLET');
	} else {
		isMobileGallery = false;
		console.log('TAAABS :: DESK');
	}


	const state = location.state.feature || getArgByPath(match.path);
	const idUrl = extractIndexFromUrl(location.pathname);
	const id = safeId(match.params.id || idUrl, 0, state.modal.length - 1);
	const [swiperPoster, updateSwiperPoster] = useState(null);
	const [isTracked, setIsTracked] = useState(false);
	const [currentIndex, setCurrentIndex] = useState(id);
	const caption = state.modal[currentIndex].caption;
	const [posterInteract, setPosterInteract] = useState(false);

	const [numUserInteractions, setNumUserInteractions] = useState(0);
	const [swiperThumbs, updateSwiperThumbs] = useState(null);

	const swiperThumbsConfigDesktop = {
		direction: 'horizontal',
		centerInsufficientSlides: true,
		loopFillGroupWithBlank: true,
		loop: false,
		freeMode: false,
		grabCursor: true,
		centeredSlides: false,
		initialSlide: currentIndex,
		slidesPerGroup: 10,
		slidesPerView: 11.5,
		slidesPerColumn: 1,
		spaceBetween: 10,
	};



	const swiperThumbsConfigTablet = {
		...swiperThumbsConfigDesktop,
		slidesPerView: 4.5,
		slidesPerGroup: 4,
		slidesPerColumn: 1,
	};

	const swiperThumbsConfigSmartphone = {
		...swiperThumbsConfigDesktop,
		slidesPerView: 2.5,
		slidesPerGroup: 2,
		slidesPerColumn: 1,
		spaceBetween: 26,
		cssMode: true,
	};

	const slideNextPoster = useCallback((speed, runCallbacks) => {
		swiperPoster && swiperPoster.slideNext(speed, runCallbacks);
	}, [swiperPoster]);

	const slidePrevPoster = useCallback((speed, runCallbacks) => {
		swiperPoster && swiperPoster.slidePrev(speed, runCallbacks);
	}, [swiperPoster]);

	const slideToPoster = useCallback((index, speed, runCallbacks, internal) => {
		console.log(`Index da bullet: ${index}`);
		swiperPoster && swiperPoster.slideTo(index, speed, runCallbacks, internal);
	}, [swiperPoster]);

	const putIdOnPath = (pathname, index) => {
		const pathArray = ensureSlashEnd(pathname, false).split('/');
		pathArray.length > 2 && pathArray.pop();
		const nupath = `${pathArray.join('/')}/${index}`;
		window.history.replaceState(null, state.modal[index].title, nupath);
	};

	const onPosterSlideChange = useCallback(() => {
		if (isTracked) {
			DataLayer.push(
				'ModalTabs_Scroll',
				state.modal[swiperPoster.realIndex].title,
				state.title,
				swiperPoster.realIndex,
			);
			setIsTracked(false);
		}
		DataLayer.push(
			'ModalTabs_MudouTab',
			state.modal[swiperPoster.realIndex].title,
			state.title,
			swiperPoster.realIndex,
		);
		setCurrentIndex(swiperPoster.realIndex);
		putIdOnPath(location.pathname, swiperPoster.realIndex);
	}, [swiperPoster, isTracked, currentIndex]);

	const onPosterTouchStart = useCallback(() => {
		setIsTracked(true);
		setPosterInteract(true);
	}, [isTracked, posterInteract]);

	const onPlayVideo = () => {
		const index = swiperPoster ? swiperPoster.realIndex : 0;
		DataLayer.push('ModalTabs_videoPlay', state.title, state.modal[index].title);
	};

	const onPauseVideo = () => {
		const index = swiperPoster ? swiperPoster.realIndex : 0;
		DataLayer.push('ModalTabs_videoPause', state.title, state.modal[index].title);
	};

	const renderTab = (item, index) => {
		return (
			<li key={index} className={cls(classes.tabItem)}>
				<DataLayer onEvent={'ModalTabs_ClicouTab'} args={[item.title, state.title, index]}>
					<button
						className={cls(classes.tabLink, { [classes.isActive]: index === currentIndex })}
						onClick={() => slideToPoster(index)}
						dangerouslySetInnerHTML={{
							__html: item.tabName,
						}}
					/>
				</DataLayer>
			</li>
		);
	};

	const renderTabs = (list) => {
		return list.length > 1 && <ul className={cls(classes.tabList)}>{list.map(renderTab)}</ul>;
	};

	const renderVideo = (item, index) => {
		return (
			<div key={index} className={cls(classes.posterVideo)}>
				<ReactPlayer
					url={item.video}
					onPlay={onPlayVideo}
					onPause={onPauseVideo}
					controls={true}
					light={false}
					width='100%'
					height='100%'
				/>
			</div>
		);
	};

	const renderPicture = (item, index) => {
		return (
			<Picture
				className={cls(classes.posterPicture)}
				classNameImg={cls(classes.posterImage, 'swiper-lazy')}
				sources={item.poster.sources}
				alt={item.poster.alt}
			/>
		);
	};

	const renderImg = (item, index) => {
		return (
			<Img
				className={cls(classes.posterImage, classes.isSimple)}
				src={item.poster}
				alt={item.alt}
				mode={'cover'}
			/>
		);
	};

	const renderPoster = (item, index) => {
		return (
			<div key={index} className={cls(classes.posterItem)}>
				<DataLayer onEvent={'ModalTabs_ClicouPoster'} args={[item.title, state.title]}>
					{isString(item.poster) ? renderImg(item, index) : renderPicture(item, index)}
				</DataLayer>
				<div className={cls(classes.posterLoader, 'swiper-lazy-preloader', 'swiper-lazy-preloader-white')} />
			</div>
		);
	};

	const renderPosters = (list) => {
		return list.map((item, index) => {
			if (item.video) return renderVideo(item, index);
			return renderPoster(item, index);
		});
	};

	const renderMiniThumbs = (list) => {
		return list.map((item, index) => {
			if (item.video) return renderVideo(item, index);
			return renderMiniThumb(item, index);
		});
	};

	const renderMiniThumb = (item, index) => {
		return (
			// <div key={index} className={cls(classes.posterItem)}>
			<div key={index}>
				<DataLayer args={[item.title, state.title]}>
					{renderPictureThumb(item, index)}
				</DataLayer>
				<div className={cls(classes.posterLoader, 'swiper-lazy-preloader', 'swiper-lazy-preloader-white')} />
			</div>
		);
	};

	const renderPictureThumb = (item, index) => {
		return (
			<div className="thumbs-gallery">
				<Picture
					classNameImg={cls('swiper-lazy')}
					sources={item.poster.sources}
					alt={item.poster.alt}
				/>
			</div>

		);
	};

	const renderThumb = (item, index) => {
		return (
			<div key={index} className={cls(classes.thumbItem)}>
				<DataLayer onEvent={'GalleryPage_ClicouThumb'} args={[index]}>
					<Img
						className={cls(classes.thumbImage, { [classes.isActive]: index === currentIndex })}
						onClick={() => slideToPoster(index)}
						data-src={item.thumbnail}
						src={item.thumbnail}
						alt={item.alt}
					/>
				</DataLayer>
			</div>
		);
	};

	const renderThumbs = (list) => {
		return list.length >= 1 && list.map(renderThumb);
	};


	const renderArrows = (item) => {
		return (
			<div className={cls(classes.arrow)}>
				<DataLayer onEvent={'AboutPage_ClicouVoltar'} args={[item.title]}>
					<BlueArrowButton className={cls(classes.arrowPrev)} onClick={() => {setPosterInteract(true); slidePrevPoster()}} disabled={currentIndex === 0} />
				</DataLayer>
				<DataLayer onEvent={'AboutPage_ClicouAvancar'} args={[item.title]}>
					<BlueArrowButton
						className={cls(classes.arrowNext)}
						onClick={() => {setPosterInteract(true); slideNextPoster()}}
						disabled={currentIndex >= state.modal.length - 1}
					/>
				</DataLayer>
			</div>
		);
	};

	const renderBullet = (item, index) => {
		return (
			<DataLayer key={index} onEvent={'MainPage_ClicouBullet'} args={[item.title, state.title]}>
				<button
					className={cls(classes.bulletItem, {
						[classes.isActive]: index === currentIndex,
					})}
					onClick={() => slideToPoster(index + 1)}
				/>
			</DataLayer>
		);
	};

	const renderBullets = (list) => {
		return list.map(renderBullet);
	};

	useEffect(() => {
		DataLayer.push('ModalTabs_Abriu', state.title);
	}, []);

	useEffect(() => {
		if (swiperPoster) {
			swiperPoster.on('slideChange', onPosterSlideChange);
			swiperPoster.on('touchStart', onPosterTouchStart);
		}
		return () => {
			if (swiperPoster) {
				swiperPoster.off('slideChange', onPosterSlideChange);
				swiperPoster.off('touchStart', onPosterTouchStart);
			}
		};
	}, [swiperPoster, isTracked]);

	useEffect(() => {
		return () => {
			DataLayer.push('Modal_Fechou_WithTitle', state.title);
		};
	}, []);

	return (
		<div className={cls(classes.root, className)}>
			{ renderArrows(state.modal[currentIndex])}
			<div className={cls(classes.poster)}>
				<ReactIdSwiper
					containerClass={cls(classes.posterList)}
					direction={'horizontal'}
					Swiper={Swiper}
					getSwiper={updateSwiperPoster}
					slidesPerView={1}
					spaceBetween={0}
					lazy={true}
					loop={true}
					autoplay={!posterInteract && state.modal.length > 1 && !state.modal[currentIndex].video}
					loopFillGroupWithBlank={true}
					grabCursor={true}
					centeredSlides={true}
					initialSlide={currentIndex}
				>
					{renderPosters(state.modal)}
				</ReactIdSwiper>
				{state.modal.length > 1 && (
					<div className={cls(classes.bullet)}>
						<div className={cls(classes.bulletList)}>{renderBullets(state.modal)}</div>
					</div>
				)}
			</div>
			
			{/* <div className={cls(classes.tab)}>{renderTabs(state.modal)}</div> */}
			{state.modal.length >= 1 && <div className={cls(classes.posterCaption)}>
				<div className={classes.posterCaptionWrapper}>
					<div className={cls(classes.posterCaptionIcon)}>
						<FiatBrand
							className={cls(classes.posterCaptionIconBrand)}
							stripes={'#edede3'}
							height={12.4}
						/>
					</div>
					<svg className={cls(classes.posterCaptionText)} viewBox="0 0 627 140">
						<text x="0" y="0"
							dangerouslySetInnerHTML={{
								__html: isString(caption) ? caption.split(/\<br\s{0,}?\/?\>/gi).map((text) =>
									`<tspan x="0" dy="1em">${text}</tspan>`
								).join('') : '&nbsp;'
							}}
						/>
					</svg>
				</div>
			</div>}

			{/* {isMobileGallery && state.modal.length > 1 && (
				<div className={cls(classes.bullet)}>
					<div className={cls(classes.bulletList)}>{renderBullets(state.modal)}</div>
				</div>
			)} */}


			{!isMobileGallery && state.modal.length >= 1 &&
			<Fade>
				{/* <div className={cls(classes.thumb)}>
					<ReactIdSwiper
						containerClass={cls(classes.thumbList)}
						Swiper={Swiper}
						getSwiper={updateSwiperThumbs}
						{...swiperThumbsConfigDesktop}
						breakpoints={{
							568: {
								...swiperThumbsConfigSmartphone,
							},
							768: {
								...swiperThumbsConfigSmartphone,
							},
							1024: {
								...swiperThumbsConfigTablet,
							},
						}}>
						{renderThumbs(state.modal)}
					</ReactIdSwiper>
					</div> */}
			</Fade>
			}
			{/* {state.modal.length >= 1 && renderMiniThumbs(state.modal)} */}
			<article className={cls(classes.info)}>
				<h2
					className={cls(classes.infoTitle)}
					dangerouslySetInnerHTML={{
						__html: state.modal[currentIndex].title,
					}}
				/>
				<p
					className={cls(classes.infoText)}
					dangerouslySetInnerHTML={{
						__html: state.modal[currentIndex][`description${
							(props.mobile || location.state.mobile) ? 'Mobile' : ''
						}`],
					}}
				/>
			</article>
		</div>
	);
};

Tabs.displayName = 'Tabs';
Tabs.propTypes = propTypes;
Tabs.defaultProps = defaultProps;
export default Tabs;
